import React from 'react';
import styled from 'styled-components';
import Floater from './floater';

const FloaterWrapper = ({
  className,
  children,
  useFloater = false,
}) => {
  if (!useFloater) {
    return children;
  }
  return (
    <>
      <Floater className={className}>
        {children}
      </Floater>
      {children}
    </>
  );
};

export default styled(FloaterWrapper)``;
